export default __webpack_public_path__ + "static/media/Chad Kirk.a93e3493.png";